<template>
  <!-- Aviso de nova versão, no estilo do WhatsApp Web: some do caminho até ter
       algo a dizer, e então avisa sem tomar a decisão pelo operador.

       Teleport para o `body` e `position: fixed` de propósito: o `.layout` é um
       flex em LINHA, e é exatamente por ser pendurado lá dentro que o convite de
       push virava uma coluna espremida no celular (BUG-051). O aviso não
       participa de fluxo de layout nenhum.

       Recarregar sozinho seria pior que não avisar: a fila é operada com
       atendimento em andamento, e um reload no meio de uma ação perde o que a
       pessoa estava fazendo. Por isso o `controllerchange` deixou de recarregar
       calado (registerServiceWorker.js) e a decisão passou a morar aqui. -->
  <Teleport to="body">
    <Transition name="app-update">
      <div
        v-if="updateAvailable"
        class="app-update-banner"
        role="status"
        aria-live="polite"
        data-test="app-update-banner"
      >
        <i class="fas fa-arrows-rotate app-update-icon"></i>
        <span class="app-update-text">
          Uma nova versão do sistema está disponível.
        </span>
        <button
          type="button"
          class="btn btn-primary app-update-apply"
          data-test="app-update-apply"
          @click="applyUpdate"
        >
          Atualizar
        </button>
        <button
          type="button"
          class="app-update-dismiss"
          aria-label="Adiar a atualização"
          data-test="app-update-dismiss"
          @click="dismiss"
        >
          Depois
        </button>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { onMounted } from "vue";
import { useAppVersion } from "@/composables/useAppVersion";

const { updateAvailable, start, dismiss, applyUpdate } = useAppVersion();

onMounted(start);
</script>

<style scoped>
.app-update-banner {
  position: fixed;
  left: 50%;
  bottom: var(--space-6);
  transform: translateX(-50%);
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  max-width: min(36rem, calc(100vw - 2 * var(--space-4)));
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  background: var(--bg-card-solid);
  box-shadow: var(--shadow-lg);
}

.app-update-icon {
  color: var(--accent-primary);
  flex-shrink: 0;
}

.app-update-text {
  color: var(--text-primary);
  font-size: var(--font-sm);
}

.app-update-apply {
  flex-shrink: 0;
}

.app-update-dismiss {
  flex-shrink: 0;
  border: none;
  background: none;
  color: var(--text-secondary);
  font-size: var(--font-sm);
  cursor: pointer;
}

.app-update-dismiss:hover {
  color: var(--text-primary);
}

.app-update-enter-active,
.app-update-leave-active {
  transition: opacity var(--transition-base), transform var(--transition-base);
}

.app-update-enter-from,
.app-update-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(0.5rem);
}

/* No celular a barra ocupa a largura e o texto quebra: apertar quatro elementos
   em 360px deixaria os alvos abaixo dos 44px do WCAG 2.5.5. */
@media (max-width: 640px) {
  .app-update-banner {
    left: var(--space-3);
    right: var(--space-3);
    bottom: var(--space-3);
    max-width: none;
    transform: none;
    flex-wrap: wrap;
  }
  .app-update-text {
    flex: 1 1 100%;
  }
  .app-update-apply {
    margin-left: auto;
  }
  .app-update-enter-from,
  .app-update-leave-to {
    transform: translateY(0.5rem);
  }
}
</style>
